
<div class="sdv-smart-block-list">
  <slot name="prepend" />
  <template v-for="(item, index) in template">
    <SmartblockItem
      :key="(item && item.id) ?? index"
      :item="item"
      class="smart-block-list__item"
      :context="context"
      :style="blockStyle"
      @action="onAction"
      @call-event="onSmartblockEvent"
      @analytics="onAnalytics"
    />
  </template>
</div>
